import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const Avatar = ({ imgUrl, showImage, name, size, col }) => {
    return (
        <div
            className={cn("avatar", {
                [`avatar_size-${size}`]: !!size,
                avatar_col: col,
            })}
        >
            {showImage && imgUrl && (
                <div className="avatar__img">
                    <img src={imgUrl} alt={`${name} avatar`} />
                </div>
            )}
            <div className="avatar__name">{name}</div>
        </div>
    );
};

Avatar.defaultProps = {
    size: "medium",
    showImage: true,
};

Avatar.propTypes = {
    imgUrl: PropTypes.string,
    showImage: PropTypes.bool,
    name: PropTypes.string.isRequired,
    col: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium", "large"]),
};

export default Avatar;
